<mat-dialog-content>
    <apcam-media-viewer-widget
        [contentType]="data.contentType"
        [fileName]="data.fileName"
        [url]="data.url"
        closeIcon="close"
        [closeLabel]="'shared.mediaViewer.closeBtnLabel' | translate"
        [showPrint]="!data.hidePrint"
        (close)="dialogRef.close()" />
</mat-dialog-content>
